module.exports = __webpack_public_path__ + "media/flags/sm-2feea9ac.svg";